import { classNames } from "@src/utils";
import { useTranslation } from "react-i18next";

interface RepeatPasswordBarProps {
  password: string;
  repeatPassword: string;
}

export default function RepeatPasswordBar({
  password,
  repeatPassword,
}: RepeatPasswordBarProps) {
  const { t } = useTranslation();

  const computeStyle = (password: string, repeatPassword: string) => {
    if (password === "" && repeatPassword === "") {
      return ["", ""];
    }
    if (password === repeatPassword) {
      return ["bg-green-500", t("account.common.repeatPasswordMatch")];
    } else {
      return ["bg-red-500", t("account.common.repeatPasswordNotMatch")];
    }
  };

  return (
    <div className="flex flex-col">
      <div className="flex flex-1 pt-1">
        <div className="overflow-hidden w-full h-4 text-xs flex justify-between rounded bg-gray-200">
          <div
            className={classNames(
              computeStyle(password, repeatPassword)[0],
              "w-full shadow-none flex text-center whitespace-nowrap text-white justify-center transition-all"
            )}
          >
            {computeStyle(password, repeatPassword)[1]}
          </div>
        </div>
      </div>
    </div>
  );
}
